module.exports = __webpack_public_path__ + "img/tr.d4a61f6a.svg";